"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PRODUCT_FRAGMENT", {
    enumerable: true,
    get: ()=>PRODUCT_FRAGMENT
});
const _graphqlRequest = require("graphql-request");
const PRODUCT_FRAGMENT = (0, _graphqlRequest.gql)`
    fragment terpeneFragment on Terpene {
        aliasList
        aromas
        description
        effects
        id
        name
        potentialHealthBenefits
        unitSymbol
    }

    fragment activeTerpeneFragment on ActiveTerpene {
        id
        terpene {
            ...terpeneFragment
        }
        name
        terpeneId
        unit
        unitSymbol
        value
    }

    fragment activeCannabinoidFragment on ActiveCannabinoid {
        cannabinoidId
        cannabinoid {
            description
            id
            name
        }
        unit
        value
    }

    fragment productFragment on Product {
        brand {
            description
            id
            imageUrl
            name
        }
        category
        description
        descriptionHtml
        effects
        enterpriseProductId
        id
        productBatchId
        image
        images {
            id
            url
            label
            description
        }
        menuTypes
        name
        slug
        posId
        potencyCbd {
            formatted
            range
            unit
        }
        potencyThc {
            formatted
            range
            unit
        }
        posMetaData {
            id
            category
            sku
        }
        staffPick
        strainType
        subcategory
        tags
        variants {
            id
            option
            priceMed
            priceRec
            specialPriceMed
            specialPriceRec
            quantity
            flowerEquivalent {
                unit
                value
            }
        }
        terpenes {
            ...activeTerpeneFragment
        }
        cannabinoids {
            ...activeCannabinoidFragment
        }
    }
`;
